module.exports = __webpack_public_path__ + "img/theme8.655cc5d0.png";